import { Module } from './base';
import { getTranslation } from "../components/i18n";
import SliderCreator from "../components/slider-creator";

class LetterSpacingModule implements Module {
  name = 'letter-spacing';

  setup(a11ySettings: Record<string, any>, modulesContainer: HTMLElement) {
    const moduleName = this.name;
    let styleContents = `
      :root {
        --accessibility-letter-spacing: 0;
      }
    `;
    styleContents += `
      *:not(style):not(script):not(noscript) {
        letter-spacing: calc(1em * var(--accessibility-letter-spacing));
      }
    `;
    let sliderValue = 0;
    if (a11ySettings[moduleName]) {
      sliderValue = a11ySettings[moduleName];
    }
    const fontsizeElement = document.createElement("div");
    fontsizeElement.className = `a11y-module a11y-module-${moduleName}`;
    fontsizeElement.innerHTML = `
      <label id="a11y-${moduleName}-label" for="a11y-${moduleName}" data-translation-field="true" data-translation-key="letterSpacing">${getTranslation('letterSpacing')}</label>
    ` + SliderCreator.createSlider(moduleName, -0.05, 0.2, 0.05, sliderValue, 0);
    modulesContainer.appendChild(fontsizeElement);
    SliderCreator.createSliderListeners(moduleName);
    return styleContents;
  }

  reset() {
    document.documentElement.style.setProperty('--accessibility-letter-spacing', '0');
    const slider = document.getElementById('a11y-letter-spacing') as HTMLInputElement;
    if (slider) {
      slider.value = '0';
      slider.dispatchEvent(new Event('input'));
    }
  }
}

export default new LetterSpacingModule();